<template>
  <div class="root-container-stm">
    <slot name="navbar">
      <navbar :logo="logo" :items="navbarItems">
        <template slot="lang-switcher">
          <language-switcher />
        </template>
      </navbar>
    </slot>
    <div class="page-content">
      <Sidebar :menu="menuVisible" @on:item:click="onMenuItemClick">
        <template #footer="">
          <MobileAppLinks />
          <ReviewUsLinks />
        </template>
      </Sidebar>
      <div class="content-wrapper">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { AdminLayout } from 'stylemix-vue-admin'
import LanguageSwitcher from '../../../console/src/language-switcher/LanguageSwitcher'
import NavbarCurrency from '../../../console/src/components/NavbarCurrency'
import Sidebar from '../../../console/src/components/Sidebar.vue'
import MobileAppLinks from '../../../console/src/components/MobileAppLinks.vue'
import ReviewUsLinks from './ReviewUsLinks.vue'
import NavbarMenu from "../../../console/src/components/NavbarMenu";

export default {
  name: 'Layout',

  components: {
    MobileAppLinks,
    LanguageSwitcher,
    NavbarCurrency,
    NavbarMenu,
    ReviewUsLinks,
    Sidebar,
  },

  extends: AdminLayout,

  data() {
    return {
      companyMenu: {
        title: '',
        items: [],
      },
    }
  },

  computed: {
    menuVisible() {
      if (!this.$account) {
        return []
      }

      return this.menu.filter(item => {
        if (!item.permission) {
          return false
        }

        if (typeof item.permission === 'function') {
          return item.permission(this)
        }

        return false // this.$allows(item.permission)
      })
    },
    navbarItems() {
      const navbarItems = []

        navbarItems.push({
          icon: 'icon-coin-euro',
          component: NavbarCurrency,
        })

      return navbarItems
    },
  },
}
</script>
